// ProtectedVideo — the one <video> element the app is allowed to render.
//
// Ad creatives are served through short-lived signed links (R2 presigned URLs
// or /videos-file media tokens), so a copied address stops working within
// minutes. This component closes the remaining casual-download paths the
// browser itself offers on top of that:
//
//   * controlsList="nodownload"      hides Chrome/Edge's Download menu entry
//   * controlsList="noremoteplayback" hides Chrome's Cast control
//   * disableRemotePlayback          blocks Cast / AirPlay via the API
//   * contextmenu preventDefault     removes "Save video as…" from right-click
//
// Known limits, stated so nobody over-trusts this:
//   * Firefox ignores controlsList, and Shift+right-click bypasses page
//     contextmenu handlers there by default, so Firefox users can still reach
//     "Save Video As…".
//   * Suppressing the context menu also removes the browser's Loop, Playback
//     speed and Picture-in-Picture menu entries on these players.
//   * A signed-in user can still fetch a signed URL from the network inspector
//     or the first-party API. Real prevention would need DRM (Widevine/FairPlay).
//
// It does stop the one-click paths that account for nearly all casual copying.

import { forwardRef } from 'react';

export const PROTECTED_VIDEO_CONTROLS_LIST = 'nodownload noremoteplayback';

// Builds the contextmenu handler: the menu is suppressed first, so a caller
// handler that throws cannot leave the native "Save video as…" menu reachable.
export function protectContextMenu(onContextMenu) {
  return (event) => {
    event.preventDefault();
    onContextMenu?.(event);
  };
}

const ProtectedVideo = forwardRef(function ProtectedVideo(
  { children, onContextMenu, ...props },
  ref,
) {
  return (
    <video
      ref={ref}
      {...props}
      controlsList={PROTECTED_VIDEO_CONTROLS_LIST}
      disableRemotePlayback
      onContextMenu={protectContextMenu(onContextMenu)}
    >
      {children}
    </video>
  );
});

export default ProtectedVideo;
